import s from './index.module.css'
import style from '../../index.module.css'
import commonStyle from '../Common/common.module.css'
import { ButtonDel } from '../../../../../UI/Button'
import classNames from 'classnames'
import { nextId } from '../../../../../../helpers/nextId'
import { useEffect, useState } from 'react'
import { useInputNew } from '@UI/InputNew/useInputNew'
import { InputNew } from '@UI/InputNew'
import { InputFormate } from '../../../../../UI/InputNew'
import { ButtonAdd, ButtonRemove } from '../Common/Buttons'
import CheckboxViolet from '@UI/New/ChecboxViolet/CheckboxViolet'
import Constructor from '@UI/New/Constructor'

export const CorrectAnswerMulti = ({ data, forProbe, edit, setErrorsList, showErrors }) => {

  const [state, setState] = useState(data['correct_answer'] ? data['correct_answer']?.map((el, index) => ({ ...el, devID: index })) : [])

  useEffect(() => {
    edit(prev => ({ ...prev, 'correct_answer': [...state?.map((el, index) => ({ text: el.text, type: el.type ?? '', index: index + 1 }))] }))
  }, [state])

  const onEdit = (text, id) => setState([...state.map(variant => (variant.devID === id) ? { ...variant, text } : variant)])

  const onEditType = (type, id) => {
    
    setErrorsList(prev => {
      const items = { ...prev.items, 
        ...(type === 'constructor' ? {[`${id}-answer-option`]: { value: false }} : {[`${id}_constructor`]: { value: false }})
      };
      let flag = true;
      for (let key in items) {
        if (items[key].value) flag = false;
      }
      return (
        { 
          valid: flag, 
          items 
        }
      )
    })

    setState([...state.map(variant => {
      return (variant.devID === id) ? { ...variant, type, text: type === 'constructor' ? [] : '' } : variant
    })])
  }

  const add = () => setState([...state, 
    { 
      text: '', 
      devID: nextId(state, 'devID'),
      ...(state[0]?.type === 'constructor' ? {type: 'constructor'} : {})
    }])
  
  const remove = id => {
    setState([...state?.filter(variant => variant.devID !== id)])
    
    setErrorsList(prev => {
      const items = { ...prev.items, [`${id}-answer-option`]: { value: false }, [`${id}_constructor`]: { value: false } };
      let flag = true;
      for (let key in items) {
        if (items[key].value) flag = false;
      }
      return (
        { 
          valid: flag, 
          items 
        }
      )
    })
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { if (!data?.correct_answer || data?.correct_answer?.length < 1) add() }, [])

  return <div className={s.wrapper}>
    <span className={style.heading}>Правильные ответы:</span>
    <div className={s.list}>
      {state?.map((variant, i) =>
        <Item 
          is_number_answer={data.is_number_answer}
          key={variant.devID} 
          type={data.type} 
          forProbe={forProbe || false}
          el={variant} index={i} 
          remove={() => remove(variant.devID)} 
          edit={v => onEdit(v, variant.devID)} 
          editType={v => onEditType(v, variant.devID)}
          setErrorsList={setErrorsList} 
          showErrors={showErrors}
          state={state} />)}
          
      <ButtonAdd onClick={add} />
    </div>
  </div>
}

const Item = ({ type, forProbe, state, el, index, edit, editType, remove, setErrorsList, showErrors, is_number_answer }) => {
  console.log('тут')
  // коменчу то, что вероятно не используется и заменяю упрощенной версией
  // const responseType = () => {
  //   if (type === 'test')
  //     return typeof el?.text === 'object' ? el?.text : el?.text ? {
  //       "type": "doc",
  //       "content": [{ "type": "paragraph", "content": [{ "type": "text", "text": el?.text }] }]
  //     } : { "type": "doc", "content": [{ "type": "paragraph", }] }
  //   return el.text ?? ''
  // }

  // const [value, setValue] = useState(responseType())
  
  // useEffect(() => { edit(value) }, [value])

  const [bindName] = useInputNew({
    name: `${el.devID}-answer-option`,
    value: el.text,
    onChange: edit,
    onError: el?.type === 'constructor' ? () => { } : setErrorsList,
    placeholder: 'Вариант ответа',
    validate: el?.type === 'constructor' ? false : showErrors,
  })
  return <div className={s.row}>
    <span className={s.booble}>{index + 1}</span>
    {/* {type === 'test' // коменчу то, что вероятно не используется и заменяю упрощенной версией
      ? <InputFormate className={style.inputNew} {...bindName} />
      : <InputNew className={style.inputNew} {...bindName} />
    } */}

    {
      el?.type !== 'constructor' && (
        <InputNew 
          classNameForBox={commonStyle.inputBox} className={style.inputNew}
          {...bindName} 
          typeValid={is_number_answer ? 'number' : 'blank'}
        />
      )
    }
    
    <div>
      {
        el?.type === 'constructor' && (
            <Constructor 
              edit={(value) => edit(value)}
              value={el.text}
              onError={setErrorsList}
              name={`${el.devID}_constructor`}
              validate={showErrors}
            />
        )
      }
      {
         !forProbe && index === 0 && state.length === 1 && (
            <div className={s.checkboxWrapper}>
              <CheckboxViolet
                  value={el?.type === 'constructor'}
                  onClick={() => {
                    if(el?.type !== 'constructor'){
                      editType('constructor');
                    }
                    else{
                      editType('')
                    }
                  }}
                  text='Конструктор'
              />
            </div>
         )
      }
      
    </div>

    {index > 0 && <ButtonRemove className={s.btnRemove} onClick={remove} />}
  </div>
}
